import { WorkspaceActionTypes } from './constants';

// ─── API Response Helpers ─────────────────────────────────────────

export const workspaceApiResponseSuccess = (actionType: string, data: any) => ({
    type: WorkspaceActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const workspaceApiResponseError = (actionType: string, error: string) => ({
    type: WorkspaceActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// ─── Action Creators ──────────────────────────────────────────────

export const fetchWorkspaces = () => ({
    type: WorkspaceActionTypes.FETCH_WORKSPACES,
    payload: {},
});

export const switchWorkspace = (workspaceId: number) => ({
    type: WorkspaceActionTypes.SWITCH_WORKSPACE,
    payload: { workspaceId },
});

export const createWorkspace = (data: { workspace_name: string; workspace_slug?: string }) => ({
    type: WorkspaceActionTypes.CREATE_WORKSPACE,
    payload: data,
});

export const inviteMember = (email: string, role: string) => ({
    type: WorkspaceActionTypes.INVITE_MEMBER,
    payload: { email, role },
});

export const fetchMembers = () => ({
    type: WorkspaceActionTypes.FETCH_MEMBERS,
    payload: {},
});

export const removeMember = (userId: number) => ({
    type: WorkspaceActionTypes.REMOVE_MEMBER,
    payload: { userId },
});

export const updateMemberRole = (userId: number, role: string) => ({
    type: WorkspaceActionTypes.UPDATE_ROLE,
    payload: { userId, role },
});

export const cancelInvitation = (invitationId: number) => ({
    type: WorkspaceActionTypes.CANCEL_INVITATION,
    payload: { invitationId },
});

export const acceptInvitation = (token: string) => ({
    type: WorkspaceActionTypes.ACCEPT_INVITATION,
    payload: { token },
});

export const resetWorkspace = () => ({
    type: WorkspaceActionTypes.RESET,
    payload: {},
});
